import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GoodModeState } from './goodmode.state';
import { UserRolesEnum } from '../../interfaces/user.interface';

export const selectGoodModeState =
  createFeatureSelector<GoodModeState>('goodModeState');

export const selectGoodModeType = createSelector(
  selectGoodModeState,
  (state: GoodModeState): UserRolesEnum | null => state.type
);
